import { FormControlLabel, Radio, TextField } from '@mui/material';
import { FormLabel } from './FormLabel';
import { genderType } from '../types';

function GenderSelection(props: {
    gender: genderType | undefined;
    setGender: (gender: genderType) => void;
}) {
    const { gender, setGender } = props;
    return (
        <>
            <FormLabel label="Genre *" />
            <FormControlLabel
                control={<Radio checked={gender?.kind === 'F'} />}
                onChange={() => setGender({ kind: 'F' })}
                label="F"
                name="gender-F"
            />
            <FormControlLabel
                control={<Radio checked={gender?.kind === 'M'} />}
                onChange={() => setGender({ kind: 'M' })}
                label="M"
                name="gender-M"
            />
            <FormControlLabel
                control={<Radio checked={gender?.kind === 'NB'} />}
                onChange={() => setGender({ kind: 'NB' })}
                label="NB"
                name="gender-NB"
            />
            <FormControlLabel
                control={<Radio checked={gender?.kind === 'other'} />}
                onChange={() => setGender({ kind: 'other', value: '' })}
                label="Autre :"
                name="gender-other"
            />
            <TextField
                label="Préciser votre genre"
                disabled={gender?.kind !== 'other'}
                name="gender-other-value"
                fullWidth
                onChange={(event) => setGender({ kind: 'other', value: event.target.value })}
                value={gender?.kind === 'other' ? gender.value : ''}
            />
        </>
    );
}

export { GenderSelection };
